import React, { Component } from 'react';
import { injectSheet } from 'redux-form-jsonschema-reactstrap'
import { InputField } from 'redux-form-jsonschema-reactstrap'
//import ReduxFormRangeSlider from './ReduxFormRangeSlider'

function cif_range(_options) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      //const name = this.props.schemaVis.schema.name
      const min = this.props.schemaVis.schema.minimum;
      const max = this.props.schemaVis.schema.maximum;
      const value = this.props.schemaVis.schema.default || undefined
      //onInput={this.form.asdf_out.value=rangeInput.value}
      return (
        <div>
          <InputField id="asdf" min={min} max={max} value={value} step="1"{...this.props} {...options} list="steplist" >
            <datalist id="steplist" style={{display:'none'}} >
              <option value="0" />
              <option value="1" />
              <option value="2" />
            </datalist>
          </InputField>
          <output id="asdf_out" htmlFor="asdf">{value}</output>
        </div>
      )
    }
  }

  return injectSheet(styles)(CreatedInputField);
}

// function cif_range2(_options) {
//   const { styles, ...options } = _options;
//   class CreatedInputField extends Component {
//     render() {
//       const name = this.props.schemaVis.schema.name
//       const min = this.props.schemaVis.schema.minimum;
//       const max = this.props.schemaVis.schema.maximum;
//       const value = this.props.schemaVis.schema.default || undefined
//       return (
//         <ReduxFormRangeSlider min={min} max={max} value={value} step="1"
//         input={<input />} {...this.props} {...options}/>
//       )
//     }
//   }
//   return injectSheet(styles)(CreatedInputField);
// }

export default cif_range({type: 'range'});
